// import { InlineWidget } from "react-calendly";
import dynamic from "next/dynamic";

// import {
import ButtonGroup from "components/Reusables/ButtonGroup";
import CenteredContainer from "components/Reusables/CenteredContainer";
import CheckList from "components/Reusables/CheckList";
import ContactCallout from "components/Reusables/ContactCallout";
import Content from "components/Reusables/Content";
import CreateAccountAndLoginButtonGroup from "components/Reusables/CreateAccountAndLoginButtonGroup";
import EmbeddedMap from "components/Reusables/EmbeddedMap";
import FormEmbed from "components/Reusables/FormEmbed";
import GeneralRichText from "@components/Reusables/GeneralRichText";
import ImageCard from "components/Reusables/ImageCard";
import LeftRightFullHeight from "components/Reusables/LeftRightFullHeight";
import LeftRightOffset from "components/Reusables/LeftRightOffset";
import MediaCardSection from "components/Reusables/MediaCardSection";
import MembershipBenefitsList from "components/Reusables/MembershipBenefitsList";
import MetaTitle from "components/Reusables/MetaTitle";
import Quote from "components/Reusables/Quote";
// import Scheduler from "components/Reusables/Scheduler";
import Title from "components/Reusables/Title";
import VerticalStatsList from "components/Reusables/VerticalStatsList";
// import UserCMEProgress from "components/Reusables/UserCMEProgress";

export default function renderItem(item, sectionIndex) {
	const model = item?.sys?.contentType?.sys.id;

	switch (model) {
		case "centeredContainer":
			return <CenteredContainer data={item} />;
		case "checklist":
			return <CheckList data={item} />;
		case "quoteBlock":
			return <Quote data={item} asItem={true} />;

		case "scheduler":
			const Scheduler = dynamic(() => import("../components/Reusables/Scheduler"));

			return <Scheduler data={item} />;
		case "statsList":
			return <VerticalStatsList data={item} />;
		case "stats":
			if (item.fields.format === "Membership Benefits List") {
				return <MembershipBenefitsList data={item} />;
			}
		case "metaTitle":
			return <MetaTitle metaTitle={item} />;

		case "buttonGroup":
			return <ButtonGroup buttonGroupData={item} />;

		case "title":
			return <Title title={item} />;

		case "content":
			if (item.fields.generalRichText) {
				return <GeneralRichText content={item} />;
			}
			return <Content content={item} />;

		case "contactCallout":
			return <ContactCallout data={item} />;

		case "hubspotForm":
			return <FormEmbed data={item} />;

		case "calendly":
			// import { InlineWidget } from "react-calendly";

			const InlineWidget = dynamic(() => import("react-calendly").then((module) => module.InlineWidget));

			return (
				<InlineWidget
					pageSettings={{
						backgroundColor: "F5F5F5",
						hideEventTypeDetails: false,
						hideLandingPageDetails: false,
						primaryColor: "265889",
						textColor: "717171",
					}}
					url={item.fields.dataUrl}
					styles={{
						height: "1020px",
						width: "100%",
					}}
				/>
			);
		case "media":
		case "mediaCard":
			return <ImageCard data={item} sectionIndex={sectionIndex} />;
		case "mediaCardSection":
			return <MediaCardSection data={item} />;

		case "singleColumnTextAndImage":
			return <LeftRightOffset data={item} />;
		case "fullHeightSection":
			return <LeftRightFullHeight data={item} sectionIndex={sectionIndex} />;

		case "jsonData":
			const internalName = item.fields.internalName;
			if (internalName === "User CME Progress") {
				const UserCMEProgress = dynamic(() => import("../components/Reusables/UserCMEProgress"), {
					ssr: false,
					// suspense: true,
				});

				return <UserCMEProgress />;
			} else if (internalName === "Create Account and Login Button Group") {
				return <CreateAccountAndLoginButtonGroup />;
			} else if (internalName.includes("With User Button Group")) {
				const WithUserButtonGroup = dynamic(() => import("../components/Reusables/WithUserButtonGroup"), {
					loading: () => <div></div>,
				});

				return <WithUserButtonGroup additionalData={item.fields.jsonData} />;
			} else if (internalName.includes("Embedded Map")) {
				return <EmbeddedMap data={item.fields.jsonData} />;
			} else {
				console.error(`Not sure what this is ${internalName}`);
			}

		default:
			return `${model} ${item?.fields?.internalName}`;
	}
}
